/* H&S collection journeys (Nov 2 2026 mobile design). Drives sections/hs-ad-landing.liquid
   for the Rental Closet (closet), Holiday edit (once), size ads (size) and ReStitched (buy).

   ONE BOX. A rental box holds exactly 5 pieces and is shared by every rental page:
   localStorage 'hs_adbox' = { items:[{id,v,pl,t,b,r,img,h,sz}], from, coll, at }, merged
   with the rental lines already in the cart ('hs_box_seen' = cart pieces seen at the last
   merge, so a piece removed in the cart leaves the box and a piece removed here is not
   pulled back in). window.HSBox = { count(), items(), onChange(cb) } for the header.
   ONE CHECKOUT (Nov 3 c, Adri approved): ReStitched pieces go straight into the same
   Shopify cart as the rental box; the header's "Your bag" sheet (hsOpenBag) checks out.

   Picking a size (pill, ?size=3-6m, or a size collection) fills an EMPTY box with a
   ready-made five in that size: available, mixed categories, no duplicates. Size is never
   stored, so it is not remembered between pages.

   PLAN CHOSEN ONCE (Nov 3 c): the shopper's plan lives in localStorage hs_plan
   (HS.getPlanChoice / setPlanChoice, snippets/hs-rent-once). With no plan yet, the
   "How would you like to rent?" sheet rises after the FIRST piece is added and only
   records the choice. With a plan, the bar shows "Rent once · $79 · Change" /
   "Monthly · $49 first month · Change" and, at 5, its button checks out straight away:
   hsChoosePlan(plan), the box replaces any rental pieces in the cart (ReStitched lines
   stay), HS.applyOffer() puts the offer code (HS.offer, STITCH59) on a Monthly cart, and
   the cart drawer opens. Members are never asked: Confirm my 5 puts the five in as $0
   Membership lines and opens the drawer. All offer wording comes from window.HS.offer.

   Alerts go through window.HSAlerts (snippets/hs-alerts): notifyBackInStock (Notify me),
   priceAlert / hasPriceAlert (ReStitched bells), saveBox (Save my box), toast (always above
   the box bar). A local toast, positioned above the bar, is the fallback. */
(function () {
  var root = document.getElementById('hsal');
  if (!root || root.__hsal) return;
  root.__hsal = 1;
  document.body.classList.add('hsal-page');

  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('hsal-cfg').textContent); } catch (e) {}
  var MODE = root.getAttribute('data-mode');
  var RENT = MODE !== 'buy';
  var READY = RENT && MODE !== 'once';           /* pages with the ready-made five */
  var MAX = 5;
  /* how many of the five we pick for them when a size is chosen (theme setting; 5 = whole box, 0 = none) */
  var READY_N = cfg.readyCount == null ? MAX : Math.min(MAX, Math.max(0, parseInt(cfg.readyCount, 10) || 0));
  var BOX_KEY = 'hs_adbox', BAG_KEY = 'hs_rsbag', SEEN_KEY = 'hs_box_seen', NOTE_KEY = 'hs_notify';
  var COLL = root.getAttribute('data-coll');
  var LABELS = cfg.sizeLabels || {};
  var ORDER = cfg.sizeOrder || [];
  function isMember() { return !!(cfg.member || (window.HS && window.HS.member === true)); }

  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var money = function (n) { n = Number(n) || 0; return '$' + (Math.round(n) === n ? n : n.toFixed(2)); };
  function load(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function save(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function sget(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function sset(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function push(ev) { try { (window.dataLayer = window.dataLayer || []).push(ev); } catch (e) {} }
  var ICON = {
    x: '<svg viewBox="0 0 256 256" aria-hidden="true"><path fill="currentColor" d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"/></svg>',
    swap: '<svg viewBox="0 0 256 256" aria-hidden="true"><path fill="currentColor" d="M213.66,181.66l-32,32a8,8,0,0,1-11.32-11.32L188.69,184H48a8,8,0,0,1,0-16H188.69l-18.35-18.34a8,8,0,0,1,11.32-11.32l32,32A8,8,0,0,1,213.66,181.66Zm-139.32-64a8,8,0,0,0,11.32-11.32L67.31,88H208a8,8,0,0,0,0-16H67.31L85.66,53.66A8,8,0,0,0,74.34,42.34l-32,32a8,8,0,0,0,0,11.32Z"/></svg>',
    plus: '<svg viewBox="0 0 256 256" aria-hidden="true"><path fill="currentColor" d="M224,128a8,8,0,0,1-8,8H136v80a8,8,0,0,1-16,0V136H40a8,8,0,0,1,0-16h80V40a8,8,0,0,1,16,0v80h80A8,8,0,0,1,224,128Z"/></svg>',
    caret: '<svg viewBox="0 0 256 256" aria-hidden="true"><path fill="currentColor" d="M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z"/></svg>',
    bell: '<svg viewBox="0 0 256 256" aria-hidden="true"><path fill="currentColor" d="M168,224a8,8,0,0,1-8,8H96a8,8,0,1,1,0-16h64A8,8,0,0,1,168,224Zm53.81-48.06C216.25,166.38,208,139.33,208,104a80,80,0,1,0-160,0c0,35.34-8.26,62.38-13.81,71.94A16,16,0,0,0,48,200H208a16,16,0,0,0,13.8-24.06Z"/></svg>'
  };

  /* keep the size pills just under the theme's pinned header: B's --hs-header-h when it
     exists, else the header section's stuck height (its sticky top + height), else 53/77px */
  function setTop() {
    var cssv = (getComputedStyle(document.documentElement).getPropertyValue('--hs-header-h') || '').trim();
    if (cssv) { root.style.setProperty('--hsal-top', 'var(--hs-header-h)'); return; }
    var h = document.querySelector('[id$="__hsnav"], .shopify-section-group-header-group');
    var top = window.innerWidth >= 750 ? 77 : 53;
    if (h) {
      var cs = getComputedStyle(h);
      if (cs.position === 'sticky') top = Math.max(0, (parseFloat(cs.top) || 0) + h.offsetHeight);
      else if (cs.position === 'fixed') top = Math.max(0, h.getBoundingClientRect().bottom);
      else {
        var stuck = null;
        $$('*', h).some(function (x) { var p = getComputedStyle(x).position; if (p === 'sticky' || p === 'fixed') { stuck = x; return true; } return false; });
        if (stuck) { var c2 = getComputedStyle(stuck); top = c2.position === 'fixed' ? stuck.getBoundingClientRect().bottom : (parseFloat(c2.top) || 0) + stuck.offsetHeight; }
      }
    }
    root.style.setProperty('--hsal-top', Math.round(top) + 'px');
  }
  setTop(); window.addEventListener('resize', setTop); window.addEventListener('load', setTop); setTimeout(setTop, 1500);

  /* ---------- product data (read from the cards) ---------- */
  function parse(el) {
    var vs = (el.getAttribute('data-vs') || '').split(',').filter(Boolean).map(function (s) {
      var a = s.split(':'); return { k: a[0], v: a[1], a: a[2] === '1' };
    });
    return {
      el: el, id: el.getAttribute('data-id'), v: el.getAttribute('data-v'), vs: vs, pl: el.getAttribute('data-pl'),
      h: el.getAttribute('data-h'), t: el.getAttribute('data-t'), b: el.getAttribute('data-b'), ty: el.getAttribute('data-ty') || '',
      r: parseFloat(el.getAttribute('data-r')) || 0, c: parseFloat(el.getAttribute('data-c')) || 0,
      loan: el.getAttribute('data-loan') === '1',
      sz: (el.getAttribute('data-sz') || '').split(' ').filter(Boolean),
      szl: (el.getAttribute('data-szl') || '').split('|').filter(Boolean),
      img: el.getAttribute('data-img'), imgs: (el.getAttribute('data-imgs') || '').split('|').filter(Boolean),
      keep: el.getAttribute('data-keep') || '', chest: el.getAttribute('data-chest') || '', len: el.getAttribute('data-len') || ''
    };
  }
  var grid = $('[data-grid]', root), emptyEl = $('[data-empty]', root);
  var list = [], byId = {};
  function register(el) {
    var d = parse(el);
    if (byId[d.id]) { el.parentNode && el.parentNode.removeChild(el); return null; }
    byId[d.id] = d; list.push(d); return d;
  }
  $$('.hsal-card', grid).forEach(register);
  /* out-on-loan pieces always sit at the end of the grid */
  function placeLoansLast() {
    list.filter(function (d) { return d.loan; }).forEach(function (d) { grid.insertBefore(d.el, emptyEl); });
    list.sort(function (a, b) { return (a.loan ? 1 : 0) - (b.loan ? 1 : 0); });
  }
  placeLoansLast();

  function variantFor(d, k) {
    if (!d) return null;
    if (!k) { var f = d.vs.filter(function (x) { return x.a; })[0]; return f ? f.v : d.v; }
    var m = d.vs.filter(function (x) { return x.k === k && x.a; })[0];
    if (m) return m.v;
    if (d.vs.length === 1 && d.vs[0].a && d.sz.indexOf(k) > -1) return d.vs[0].v;
    return null;
  }
  function slim(d, k) {
    var v = variantFor(d, k) || variantFor(d, '') || d.v;
    var lab = '';
    d.vs.forEach(function (x, i) { if (x.v === v) lab = varLabel(d, i); });
    return { id: d.id, v: v, pl: d.pl, t: d.t, b: d.b, r: d.r, img: d.img, h: d.h, sz: lab };
  }
  function idOf(x) { return String(x.id); }
  /* one size wording everywhere, as the design's pills: NB 0-3M 3-6M 6-12M 12-18M 18-24M 2T */
  function varLabel(d, i) {
    var x = d.vs[i] || {};
    if (x.k && LABELS[x.k]) return LABELS[x.k];
    return String(d.szl[i] || '').toUpperCase().replace(/\s+/g, '');
  }
  function sizesText(d) {
    var ks = ORDER.filter(function (k) { return d.sz.indexOf(k) > -1; });
    return ks.length ? ks.map(function (k) { return LABELS[k] || k; }).join(' · ') : d.szl.map(function (s, i) { return varLabel(d, i); }).join(' · ');
  }

  /* ---------- box / bag state ---------- */
  var box = [], bag = [];
  var autoK = '', autoIds = '';     /* the size the ready-made five was picked for, untouched */
  (function () {
    var saved = load(BOX_KEY);
    box = ((saved && saved.items) || []).filter(function (x) { var d = byId[x.id]; return x && x.id && !(d && d.loan); }).slice(0, MAX);
  })();
  function inBox(id) { return box.some(function (x) { return String(x.id) === String(id); }); }
  function inBag(id) { return bag.some(function (x) { return String(x.id) === String(id); }); }
  var listeners = [];
  function emit() {
    listeners.forEach(function (cb) { try { cb(box.slice()); } catch (e) {} });
    try { document.dispatchEvent(new CustomEvent('hs:box', { detail: { count: box.length, items: box.slice(), bag: bag.length } })); } catch (e) {}
  }
  function persist() {
    if (RENT) save(BOX_KEY, { items: box, from: MODE, coll: COLL, at: Date.now() });
    emit();
  }
  window.HSBox = {
    count: function () { return box.length; },
    items: function () { return box.slice(); },
    onChange: function (cb) { if (typeof cb === 'function') listeners.push(cb); }
  };
  /* window.HSBag belongs to the header's "Your bag" sheet (snippets/hs-sw-bag); we only tell it the bag changed */
  function bagChanged() { try { document.dispatchEvent(new CustomEvent('hs:bag-changed', { detail: { bag: bag.length } })); } catch (e) {} }

  /* ---------- toast (always above the box bar) ---------- */
  var toastEl = $('[data-toast]'), toastT;
  function toastAct(msg, label, fn) {
    if (!toastEl) return toast(msg);
    toastEl.innerHTML = '<span>' + esc(msg) + '</span><button type="button" class="vb">' + esc(label) + '</button>';
    toastEl.classList.add('on', 'act'); clearTimeout(toastT);
    $('.vb', toastEl).onclick = function () { toastEl.classList.remove('on', 'act'); fn(); };
    toastT = setTimeout(function () { toastEl.classList.remove('on', 'act'); }, 4000);
  }
  function toast(msg, icon) {
    if (toastEl) toastEl.classList.remove('act');
    if (window.HSAlerts && typeof window.HSAlerts.toast === 'function') { try { window.HSAlerts.toast(msg); return; } catch (e) {} }
    if (!toastEl) return;
    toastEl.innerHTML = (icon ? ICON.bell : '') + '<span>' + esc(msg) + '</span>';
    toastEl.classList.add('on'); clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('on'); }, 2600);
  }
  var bxEl = $('[data-bx]');
  /* Nov 4 2026 (Adri): minimised box bar — remembered for the visit; adding a piece opens it again */
  function setBarMin(on) {
    if (!bxEl) return;
    bxEl.classList.toggle('min', !!on);
    var mb = $('[data-act="minbar"]', bxEl); if (mb) mb.setAttribute('aria-expanded', on ? 'false' : 'true');
    sset('hs_bar_min', on ? '1' : '');
    measureBar();
  }
  function measureBar() {
    var hgt = 0;
    if (bxEl && !bxEl.hidden) { var r = bxEl.getBoundingClientRect(); hgt = Math.max(0, window.innerHeight - r.top); }
    document.documentElement.style.setProperty('--hsal-bar', hgt + 'px');
    document.documentElement.style.setProperty('--hs-bottom-bar', hgt + 'px');
  }

  /* ---------- active size + filters ---------- */
  var active = { size: '', cats: {}, brands: {}, price: '', avail: false };
  function sizeLabel(k) { return LABELS[k] || k; }
  function priceBand(r) { return r < 25 ? 'Under $25' : (r <= 50 ? '$25–$50' : '$50+'); }

  /* ---------- offer + plan (single sources: HS.offer, HS.getPlanChoice) ---------- */
  function offer() {
    var o = (window.HS && window.HS.offer) || {};
    var first = o.first != null ? o.first : 49, then = o.then != null ? o.then : 59;
    return { code: o.code || '', firstLabel: o.firstLabel || ('$' + first), thenLabel: o.thenLabel || ('$' + then) };
  }
  function storedPlan() {
    if (isMember()) return null;
    var HS = window.HS;
    var p = HS && HS.getPlanChoice ? HS.getPlanChoice() : null;
    return p === 'once' || p === 'member' ? p : null;
  }
  function planLine(p) { return p === 'once' ? 'Rent once · $79' : 'Monthly · ' + offer().firstLabel + ' first month'; }
  function planButton(p) { return p === 'once' ? 'Check out · $79' : 'Join · ' + offer().firstLabel + ' today'; }

  /* ---------- rendering ---------- */
  function renderBar() {
    if (!bxEl) return;
    if (!RENT) {
      bxEl.hidden = !bag.length;
      var tot = bag.reduce(function (a, x) { return a + (Number(x.r) || 0); }, 0);
      $('[data-bx-n]', bxEl).textContent = bag.length + (bag.length === 1 ? ' piece' : ' pieces') + ' in your bag · ' + money(tot);
      measureBar(); return;
    }
    var n = box.length, full = n >= MAX, mem = isMember();
    if (!bxEl.__minInit) { bxEl.__minInit = 1; if (sget('hs_bar_min') === '1') bxEl.classList.add('min'); }
    $('[data-bx-sl]', bxEl).innerHTML = Array.apply(null, Array(MAX)).map(function (_, i) {
      return box[i] ? '<img src="' + esc(box[i].img) + '" alt="">' : '<span></span>';
    }).join('');
    var sp = storedPlan(), subEl = $('[data-bx-sub]', bxEl);
    /* short enough for one glance on a phone: "5 of 5" / "Monthly $49 first month · Change" */
    $('[data-bx-n]', bxEl).textContent = n + ' of ' + MAX + (sp ? '' : ' chosen');
    if (sp) subEl.innerHTML = esc(sp === 'once' ? 'Rent once $79' : 'Monthly ' + offer().firstLabel + ' first month') + ' · <a href="#" class="chg" data-act="changeplan">Change</a>';
    else subEl.textContent = full ? cfg.readyLine : (mem ? cfg.barLineMember : (MODE === 'size' ? offer().firstLabel + ' first month' : cfg.barLine)) || '';
    var go = $('[data-act="go"]', bxEl);
    go.classList.toggle('on', full);
    if (!busy) go.textContent = full ? (mem ? 'Confirm' : (sp ? planButton(sp) : (MODE === 'once' ? 'Rent · $79' : 'Continue'))) : 'Add ' + (MAX - n);
    measureBar();
  }
  function markCards() {
    var note = load(NOTE_KEY) || [];
    list.forEach(function (d) {
      var has = RENT ? inBox(d.id) : inBag(d.id);
      d.el.classList.toggle('in', has);
      var b = $('.hsal-add', d.el);
      if (b) b.setAttribute('aria-label', has ? (RENT ? 'In your box. Tap to remove' : 'In your bag. Tap to remove') : (RENT ? 'Add to box' : 'Add to bag'));
      if (d.loan) {
        var nt = $('.hsal-nt', d.el), on = note.indexOf(d.id) > -1 || !!(window.HSAlerts && HSAlerts.hasNotify && HSAlerts.hasNotify(Number(d.v)));
        if (nt) { nt.classList.toggle('on', on); nt.setAttribute('aria-pressed', on ? 'true' : 'false'); $('span', nt).textContent = on ? 'We’ll let you know' : 'Notify me'; }
      }
      if (!RENT) {
        var w = $('.hsal-watch', d.el), wo = !!(window.HSAlerts && HSAlerts.hasPriceAlert && HSAlerts.hasPriceAlert(d.id));
        if (w) { w.classList.toggle('on', wo); w.setAttribute('aria-pressed', wo ? 'true' : 'false'); w.setAttribute('aria-label', wo ? 'Price alert on' : 'Alert me if the price drops'); }
      }
    });
  }
  var rbEl = $('[data-rb]', root), ownEl = $('[data-own]', root);
  function renderRB() {
    if (!rbEl) return;
    var k = active.size;
    var show = READY && !!k;
    rbEl.hidden = !show; if (ownEl) ownEl.hidden = !show;
    if (!show) return;
    var n = box.length;
    var picked = n && n < MAX && autoK && autoIds === box.map(idOf).join(',');   /* our picks, untouched, box not full */
    $('[data-rb-h]', rbEl).innerHTML = (n === MAX ? 'We picked 5 for ' : (picked ? 'We picked ' + n + ' for ' : n + ' of 5 for ')) + '<span class="hsal-nw">' + esc(sizeLabel(k)) + '</span>' + (n && n < MAX ? ' · choose ' + (MAX - n) + ' more' : '');
    var clr = $('[data-act="clearbox"]', rbEl); if (clr) clr.hidden = !n;
    var html = box.map(function (x) {
      return '<div class="hsal-rb-it" data-bid="' + esc(x.id) + '"><div class="im"><img src="' + esc(x.img) + '" alt="' + esc(x.t) + '">' +
        '<button type="button" class="rm" data-rbx="' + esc(x.id) + '" aria-label="Remove ' + esc(x.t) + '">' + ICON.x + '</button></div>' +
        '<div class="t">' + esc(x.t) + '</div>' +
        '<button type="button" class="sw2" data-swap="' + esc(x.id) + '">' + ICON.swap + 'Swap</button></div>';
    }).join('');
    for (var i = n; i < MAX; i++) html += '<div class="hsal-rb-it"><div class="im empty" data-act="addbelow" role="button" tabindex="0" aria-label="Add from below">' + ICON.plus + '</div><div class="t empty">Add from below</div></div>';
    $('[data-rb-row]', rbEl).innerHTML = html;
  }
  function refresh() {
    markCards(); renderBar(); renderRB();
    if (openSheet && openSheet.getAttribute('data-sheet') === 'box') renderBoxSheet();
  }

  function applyFilters() {
    var shown = 0;
    list.forEach(function (d) {
      var ok = true;
      if (active.size && d.sz.indexOf(active.size) === -1) ok = false;
      /* Nov 4 2026: a size that is out on loan (Supercycle per-variant flag) is not offered under its pill */
      if (RENT && active.size && ok && !variantFor(d, active.size)) ok = false;
      if (RENT && active.avail && d.loan) ok = false;
      var cs = Object.keys(active.cats); if (cs.length && cs.indexOf(d.ty) === -1) ok = false;
      var bs = Object.keys(active.brands); if (bs.length && bs.indexOf(d.b) === -1) ok = false;
      if (active.price && priceBand(d.r) !== active.price) ok = false;
      d.el.hidden = !ok; if (ok) shown++;
    });
    var cnt = $('[data-count]', root); if (cnt && !(LOADING && (OWN || grid.getAttribute('data-pages') !== '1'))) cnt.textContent = shown;
    var noun = $('[data-noun]', root);
    if (noun) noun.textContent = active.size ? String(cfg.nounSize || cfg.noun || '').replace('[size]', sizeLabel(active.size)) : (cfg.noun || '');
    if (emptyEl) emptyEl.hidden = shown > 0;
    var nf = Object.keys(active.cats).length + Object.keys(active.brands).length + (active.price ? 1 : 0) + (active.avail ? 1 : 0);
    var fc = $('[data-fcount]', root); if (fc) { fc.textContent = nf || ''; fc.classList.toggle('on', nf > 0); }
    $$('.hsal-pill', root).forEach(function (p) { var on = (p.getAttribute('data-k') || '') === active.size; p.classList.toggle('on', on); p.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    renderRB();
    /* "Browse the full Rental Closet" keeps the size picked here */
    var slug = { newborn: 'newborn', '0-3': '0-3m', '3-6': '3-6m', '6-12': '6-12m', '12-18': '12-18m', '18-24': '18-24m', '2t': '2t', '3t': '3t' }[active.size];
    $$('[data-closet-link]', root).forEach(function (a) {
      var base = (a.getAttribute('data-base') || a.getAttribute('href') || '/collections/rental-eligible').split('?')[0];
      a.setAttribute('data-base', base);
      a.setAttribute('href', base + (slug ? '?size=' + slug : ''));
    });
  }
  var OWN = root.getAttribute('data-own') === '1';   /* size page listing only its own collection */
  var LOADING = true;                                 /* until the other pages are in, keep the server count */
  function showPills() {
    if (OWN) return;
    var present = {};
    list.forEach(function (d) { if (!d.loan) d.sz.forEach(function (k) { present[k] = 1; }); });
    $$('.hsal-pill[data-k]', root).forEach(function (p) { var k = p.getAttribute('data-k'); if (k) p.hidden = !present[k] && k !== active.size; });
    /* "Every piece shows flat measurements." only when measurements exist */
    var more = $('[data-fit-more]', root);
    if (more) more.hidden = !list.some(function (d) { return d.chest || d.len; });
  }

  /* ---------- add / remove ---------- */
  function fullMsg() { return (window.HS && window.HS.fullMsg) || 'Your box is full — 5 pieces max. Remove one to swap it for this piece.'; }
  function touched() { autoK = ''; autoIds = ''; }
  function addPiece(id, k) {
    var d = byId[id]; if (!d) return false;
    if (inBox(id)) return true;
    if (d.loan) { toast('That piece is out on loan right now.'); return false; }
    if (box.length >= MAX) { toast(fullMsg()); return false; }
    /* Nov 4 2026: never swap in another size silently — if the chosen size is out on loan, say so */
    var kk = k == null ? active.size : k;
    if (RENT && kk && !variantFor(d, kk)) { toast('That size is out on loan right now. Try another size.'); return false; }
    if (RENT && !kk && !variantFor(d, '')) { toast('That piece is out on loan right now.'); return false; }
    box.push(slim(d, kk));
    if (bxEl && bxEl.classList.contains('min')) setBarMin(false);
    touched(); persist(); refresh();
    if (box.length === MAX) push({ event: 'hs_box_filled', page: MODE, utm_campaign: new URLSearchParams(location.search).get('utm_campaign') || '' });
    var free = function () { return !openSheet || openSheet.getAttribute('data-sheet') === 'ql'; };
    /* no plan yet: "How would you like to rent?" rises after the first piece (once per visit);
       members: "These 5 are coming next." rises at five */
    if (!isMember() && !storedPlan() && !sget('hs_plan_asked')) {
      sset('hs_plan_asked', '1');
      setTimeout(function () { if (free()) openPlan(true); }, 450);
    } else if (isMember() && box.length === MAX) {
      setTimeout(function () { if (box.length === MAX && free()) openConfirm(); }, 450);
    }
    return true;
  }
  function removePiece(id, why) {
    box = box.filter(function (x) { return String(x.id) !== String(id); });
    touched(); persist(); refresh();
    if (why === 'x') maybeSave();
  }
  function toggle(id) {
    if (RENT) { if (inBox(id)) removePiece(id); else addPiece(id); return; }
    var d = byId[id]; if (!d) return;
    var was = inBag(id), x = slim(d, '');
    if (was) bag = bag.filter(function (y) { return String(y.id) !== String(id); }); else bag.push(x);
    refresh();
    /* one checkout: ReStitched pieces go straight into the Shopify cart */
    var req = was ? write('/cart/change.js', { id: String(bag0v(id) || x.v), quantity: 0 }) : write('/cart/add.js', { items: [{ id: parseInt(x.v, 10), quantity: 1 }] });
    req.then(function (r) {
      if (!r.ok) {
        if (was) bag.push(x); else bag = bag.filter(function (y) { return String(y.id) !== String(id); });
        refresh(); toast(was ? 'That piece could not be removed. Please try again.' : 'That piece could not be added. Please try again.'); return;
      }
      if (was) toast('Removed from your bag.');
      else if (window.hsOpenBag) toastAct('Added to your bag', 'View bag', function () { window.hsOpenBag(); });
      else toast('Added to your bag');
      bagChanged(); emit();
    });
  }

  var bagV = {};
  function bag0v(id) { return bagV[String(id)]; }
  /* the bag = ReStitched (non-rental) lines in the cart; leftovers from the old browser bag move in */
  function loadBag() {
    if (RENT) return;
    var HS = window.HS || {};
    freshCart().then(function (cart) {
      var lines = (cart.items || []).filter(function (it) {
        return !it.selling_plan_allocation && !(HS.isMembershipLine && HS.isMembershipLine(it)) && !(HS.isAuthLine && HS.isAuthLine(it)) && !(HS.isExtraLine && HS.isExtraLine(it));
      });
      bagV = {}; lines.forEach(function (it) { bagV[String(it.product_id)] = String(it.variant_id); });
      bag = lines.map(function (it) { var d = byId[String(it.product_id)]; return d ? slim(d, '') : { id: String(it.product_id), v: String(it.variant_id), t: it.product_title, r: (it.final_price || 0) / 100 }; });
      var old = load(BAG_KEY) || [];
      var add = (Array.isArray(old) ? old : []).filter(function (x) { return x && x.v && !lines.some(function (it) { return String(it.variant_id) === String(x.v); }); });
      try { localStorage.removeItem(BAG_KEY); } catch (e) {}
      if (add.length) return write('/cart/add.js', { items: add.map(function (x) { return { id: parseInt(x.v, 10), quantity: 1 }; }) }).then(function () { bagChanged(); return loadBag(); });
      refresh(); emit();
    }, function () {});
  }

  /* ---------- ready-made five ---------- */
  function candidates(k, exclude) {
    var seenT = {};
    box.forEach(function (x) { seenT[String(x.t || '').toLowerCase()] = 1; });
    return list.filter(function (d) {
      if (d.loan || !d.pl || exclude[d.id] || inBox(d.id)) return false;
      if (!variantFor(d, k) || d.sz.indexOf(k) === -1) return false;
      var tk = String(d.t || '').toLowerCase();
      if (seenT[tk]) return false;
      seenT[tk] = 1; return true;
    });
  }
  function readyFive(k) {
    var c = candidates(k, {});
    var byType = {}, types = [];
    c.forEach(function (d) { var t = d.ty || 'Other'; if (!byType[t]) { byType[t] = []; types.push(t); } byType[t].push(d); });
    var out = [];
    while (out.length < READY_N && types.some(function (t) { return byType[t].length; })) {
      types.forEach(function (t) { if (out.length < READY_N && byType[t].length) out.push(byType[t].shift()); });
    }
    return out;
  }
  function fillFor(k) {
    if (!READY || !k || !READY_N) return;
    var untouchedAuto = autoK && autoIds === box.map(idOf).join(',');
    if (box.length && !untouchedAuto) return;
    if (untouchedAuto) box = [];
    var five = readyFive(k);
    if (!five.length) { refresh(); return; }
    box = five.map(function (d) { return slim(d, k); });
    autoK = k; autoIds = box.map(idOf).join(',');
    persist(); refresh();
    push({ event: 'hs_box_ready_five', size: k, page: MODE });
    if (box.length === MAX) push({ event: 'hs_box_filled', page: MODE, utm_campaign: new URLSearchParams(location.search).get('utm_campaign') || '' });
  }
  function pickSize(k, opts) {
    active.size = k || '';
    applyFilters();
    if (k && !(opts && opts.nofill)) fillFor(k);
  }

  /* ---------- sheets ---------- */
  var shbg = $('[data-shbg]');
  var openSheet = null, lastFocus = null;
  function show(name) {
    close(true);
    var sh = $('[data-sheet="' + name + '"]'); if (!sh) return null;
    addX(sh);
    lastFocus = document.activeElement;
    sh.hidden = false; if (shbg) shbg.hidden = false; openSheet = sh;
    document.body.classList.add('hsal-lock');
    sh.scrollTop = 0;
    return sh;
  }
  function close(quiet) {
    if (openSheet) openSheet.hidden = true;
    openSheet = null; if (shbg) shbg.hidden = true;
    document.body.classList.remove('hsal-lock');
    if (!quiet && lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  if (shbg) shbg.addEventListener('click', function () { close(); });
  /* every sheet gets an × (top right) that just closes it; nothing is saved */
  function addX(sh) {
    if (!sh || sh.querySelector('.hsal-x') || sh.classList.contains('hsal-fs')) return;
    var x = document.createElement('button'); x.type = 'button'; x.className = 'hsal-x'; x.setAttribute('data-act', 'close'); x.setAttribute('aria-label', 'Close');
    x.innerHTML = ICON.x; sh.insertBefore(x, sh.firstChild);
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openSheet) close(); });
  function thumbs(sh) { var t = $('[data-thumbs]', sh); if (t) t.innerHTML = box.map(function (x) { return '<img src="' + esc(x.img) + '" alt="' + esc(x.t) + '">'; }).join(''); }

  /* "Your box" review (tap the bar) — built here so the section stays simple */
  var boxSheet = document.createElement('div');
  boxSheet.className = 'hsal-sh'; boxSheet.setAttribute('data-sheet', 'box'); boxSheet.setAttribute('role', 'dialog');
  boxSheet.setAttribute('aria-modal', 'true'); boxSheet.setAttribute('aria-label', RENT ? 'Your box' : 'Your bag'); boxSheet.hidden = true;
  boxSheet.innerHTML = '<div class="hsal-grab"></div><span class="hsal-eye">' + (RENT ? 'Your box' : 'ReStitched · yours to keep') + '</span>' +
    '<h3 class="hsal-pc-h" data-bxs-h></h3><div class="hsal-swl" data-bxs-l></div>' +
    '<button type="button" class="hsal-go" data-bxs-go></button><p class="hsal-fine" data-bxs-fine></p>';
  document.body.appendChild(boxSheet);
  function renderBoxSheet() {
    var items = RENT ? box : bag, n = items.length, full = n >= MAX;
    var tot = bag.reduce(function (a, x) { return a + (Number(x.r) || 0); }, 0);
    $('[data-bxs-h]', boxSheet).textContent = RENT ? (n + ' of ' + MAX + ' chosen') : (n + (n === 1 ? ' piece · ' : ' pieces · ') + money(tot));
    $('[data-bxs-l]', boxSheet).innerHTML = n ? items.map(function (x) {
      var line = RENT ? ((x.sz ? x.sz + ' · ' : '') + (x.r ? 'Retail ' + money(x.r) : 'Included in your box')) : money(x.r);
      return '<div class="hsal-swi"><img src="' + esc(x.img) + '" alt=""><div><span class="v">' + esc(x.b) + '</span><b>' + esc(x.t) + '</b><span class="s">' + esc(line) + '</span></div>' +
        '<button type="button" class="rm" data-rm="' + esc(x.id) + '" aria-label="Remove ' + esc(x.t) + '">Remove</button></div>';
    }).join('') : '<p class="hsal-bxs-empty">' + (RENT ? 'Your box is empty. Tap + on any piece to add it.' : 'Your bag is empty.') + '</p>';
    var go = $('[data-bxs-go]', boxSheet);
    if (RENT) {
      go.textContent = full ? (isMember() ? 'Confirm' : 'Continue') : (n ? 'Choose ' + (MAX - n) + ' more' : 'Start choosing');
      go.setAttribute('data-mode', full ? 'plan' : 'shop');
      $('[data-bxs-fine]', boxSheet).textContent = 'A box is 5 pieces. Free shipping both ways.';
    } else {
      go.textContent = n ? 'Check out · ' + money(tot) : 'Keep shopping';
      go.setAttribute('data-mode', n ? 'buy' : 'shop');
      $('[data-bxs-fine]', boxSheet).textContent = 'Separate from rentals. ReStitched pieces are yours to keep.';
    }
  }
  function openBox() {
    var items = RENT ? box : bag;
    if (!items.length) { toast(RENT ? 'Tap + on a piece to start your box.' : 'Tap the bag on a piece to add it.'); return; }
    renderBoxSheet(); show('box');
  }

  /* quick look */
  var qlId = null;
  function quickLook(id) {
    var d = byId[id]; if (!d || !RENT) return;
    qlId = id;
    var sh = $('[data-sheet="ql"]');
    var imgs = d.imgs.length ? d.imgs : [d.img];
    var im = $('[data-ql-im]', sh);
    im.innerHTML = imgs.map(function (u, i) { return '<img src="' + esc(u) + '" alt="' + esc(d.t) + (imgs.length > 1 ? ', photo ' + (i + 1) : '') + '"' + (i ? ' loading="lazy"' : '') + '>'; }).join('');
    im.scrollLeft = 0;
    var dots = $('[data-ql-dots]', sh);
    dots.innerHTML = imgs.length > 1 ? imgs.map(function (_, i) { return '<i' + (i ? '' : ' class="on"') + '></i>'; }).join('') : '';
    $('[data-ql-v]', sh).textContent = d.b;
    $('[data-ql-t]', sh).textContent = d.t;
    $('[data-ql-p]', sh).textContent = 'Retail ' + money(d.r) + ' · included in your box';
    var mine = box.filter(function (y) { return String(y.id) === String(id); })[0];
    var want = mine ? mine.v : (variantFor(d, active.size) || variantFor(d, ''));
    $('[data-ql-sz]', sh).innerHTML = d.szl.map(function (s, i) {
      var x = d.vs[i] || {}; var cls = !x.a ? 'off' : (want && x.v === want ? 'on' : '');
      return '<span' + (cls ? ' class="' + cls + '"' : '') + '>' + esc(varLabel(d, i)) + '</span>';
    }).join('');
    var fit = $('[data-ql-fit]', sh);
    if (d.chest || d.len) {
      var bits = []; if (d.chest) bits.push('chest ' + d.chest + ' cm'); if (d.len) bits.push('length ' + d.len + ' cm');
      $('[data-ql-fit-t]', sh).innerHTML = '<b>Measured flat:</b> ' + esc(bits.join(' · ')) + '. Brands fit differently, so check against something that fits now.';
      fit.hidden = false;
    } else fit.hidden = true;
    $('[data-ql-link]', sh).href = d.h;
    var add = $('[data-ql-add]', sh);
    add.disabled = !!d.loan;
    add.textContent = d.loan ? 'Out on loan' : (inBox(id) ? 'In your box ✓' : 'Add to box');
    show('ql');
  }
  (function () {
    var im = $('[data-ql-im]'); if (!im) return;
    im.addEventListener('scroll', function () {
      var i = Math.round(im.scrollLeft / Math.max(1, im.clientWidth));
      $$('[data-ql-dots] i').forEach(function (x, j) { x.classList.toggle('on', j === i); });
    }, { passive: true });
  })();

  /* swap */
  var swapId = null;
  function nextSize(k) { var i = ORDER.indexOf(k); return i > -1 && i < ORDER.length - 1 ? ORDER[i + 1] : ''; }
  function openSwap(id) {
    var x = box.filter(function (y) { return String(y.id) === String(id); })[0]; if (!x) return;
    swapId = id;
    var d = byId[id];
    var k = active.size || (d && d.sz[0]) || '';
    var sh = $('[data-sheet="swap"]');
    $('[data-sw-img]', sh).src = x.img;
    var excl = {}; excl[id] = 1;
    var ownD = d ? [d] : [];
    var first = k ? candidates(k, excl) : [];
    var sameType = function (a, b) { return (a.ty === (ownD[0] && ownD[0].ty) ? 0 : 1) - (b.ty === (ownD[0] && ownD[0].ty) ? 0 : 1); };
    first = first.slice(0, 40).sort(sameType).slice(0, 12);
    var nk = nextSize(k), taken = {}; first.forEach(function (o) { taken[o.id] = 1; }); taken[id] = 1;
    var second = nk ? candidates(nk, taken).slice(0, 8) : [];
    function row(o, kk) {
      return '<div class="hsal-swi"><img src="' + esc(o.img) + '" alt=""><div><span class="v">' + esc(o.b) + '</span><b>' + esc(o.t) + '</b><span class="s">' +
        esc((sizesText(o) ? sizesText(o) + ' · ' : '') + 'Retail ' + money(o.r)) + '</span></div>' +
        '<button type="button" data-swapin="' + esc(o.id) + '" data-k="' + esc(kk) + '">Swap in</button></div>';
    }
    var html = first.map(function (o) { return row(o, k); }).join('');
    if (second.length) html += (first.length ? '<div class="hsal-swh">A size up · ' + esc(sizeLabel(nk)) + '</div>' : '') + second.map(function (o) { return row(o, nk); }).join('');
    $('[data-sw-l]', sh).innerHTML = html || '<p class="hsal-bxs-empty">Nothing else in this size right now.</p>';
    show('swap');
  }
  function swapIn(nid, k) {
    var d = byId[nid]; if (!d || swapId == null) return;
    box = box.map(function (x) { return String(x.id) === String(swapId) ? slim(d, k) : x; });
    touched(); swapId = null; persist(); refresh(); close();
  }

  /* rent question (non-members) */
  var plan = cfg.planPre === 'once' ? 'once' : 'member';
  var planMode = 'checkout';     /* 'choose' = record the plan only (fewer than 5 pieces) */
  function setPlan(p) {
    plan = p;
    $$('[data-plan]').forEach(function (o) { var on = o.getAttribute('data-plan') === p; o.classList.toggle('on', on); o.setAttribute('aria-checked', on ? 'true' : 'false'); });
    var go = $('[data-act="checkout"]');
    if (go) go.textContent = planMode === 'choose' ? (p === 'once' ? 'Continue with Rent once' : 'Continue with Monthly') : planButton(p);
  }
  function openPlan(choose) {
    if (isMember()) { if (box.length >= MAX) openConfirm(); return; }
    planMode = choose || box.length < MAX ? 'choose' : 'checkout';
    var sh = $('[data-sheet="plan"]'); if (!sh) return;
    thumbs(sh);
    var o = offer();
    var mp = $('[data-member-price]', sh);
    if (mp) mp.innerHTML = '<b>' + esc(o.firstLabel) + '</b> first month, then ' + esc(o.thenLabel) + '/month';
    var eye = $('.hsal-eye', sh); if (eye) eye.textContent = 'Your box · ' + (planMode === 'choose' ? box.length + ' of 5' : '5 pieces');
    if (storedPlan()) plan = storedPlan();
    var err = $('[data-err]', sh); err.classList.remove('on');
    setPlan(plan);
    show('plan');
    push({ event: 'hs_rent_question', page: MODE });
  }
  function openConfirm() {
    var sh = $('[data-sheet="confirm"]'); if (!sh) return;
    thumbs(sh); $('[data-err]', sh).classList.remove('on');
    show('confirm');
  }
  $$('[data-plan]').forEach(function (o) {
    o.addEventListener('click', function () { setPlan(o.getAttribute('data-plan')); });
    o.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setPlan(o.getAttribute('data-plan')); } });
  });

  /* ---------- filter drawer: Size, Category, Brand, Price — only values with stock ---------- */
  var draft = null;
  function groups() {
    var sizes = {}, cats = {}, brands = {}, prices = {};
    list.forEach(function (d) {
      if (d.loan) return;
      d.sz.forEach(function (k) { sizes[k] = 1; });
      if (d.ty) cats[d.ty] = 1; if (d.b) brands[d.b] = 1; prices[priceBand(d.r)] = 1;
    });
    var g = [];
    var sz = ORDER.filter(function (k) { return sizes[k]; });
    if (!RENT && sz.length) g.push({ key: 'size', label: 'Size', vals: sz, single: true, lab: sizeLabel });
    var c = Object.keys(cats).sort(); if (c.length) g.push({ key: 'cats', label: 'Category', vals: c });
    var b = Object.keys(brands).sort(); if (b.length) g.push({ key: 'brands', label: 'Brand', vals: b });
    var p = ['Under $25', '$25–$50', '$50+'].filter(function (x) { return prices[x]; }); if (!RENT && p.length) g.push({ key: 'price', label: 'Price', vals: p, single: true });
    return g;
  }
  var openG = RENT ? 'cats' : 'size';
  function renderGroups() {
    var wrap = $('[data-fgroups]'); if (!wrap) return;
    var gs = groups();
    if (!gs.some(function (g) { return g.key === openG; })) openG = gs[0] && gs[0].key;
    wrap.innerHTML = gs.map(function (g) {
      var open = g.key === openG;
      return '<div class="hsal-fg' + (open ? ' open' : '') + '" data-g="' + g.key + '"><button type="button" class="hsal-fh" aria-expanded="' + open + '">' + g.label + ICON.caret + '</button><div class="hsal-fv">' +
        g.vals.map(function (v) {
          var on = g.single ? draft[g.key] === v : !!draft[g.key][v];
          return '<button type="button" class="' + (on ? 'on' : '') + '" aria-pressed="' + on + '" data-fv="' + esc(v) + '">' + esc(g.lab ? g.lab(v) : v) + '</button>';
        }).join('') + '</div></div>';
    }).join('') || '<p class="hsal-ql-p" style="padding:14px 0">Nothing to filter here yet.</p>';
  }
  function openFilter() { draft = JSON.parse(JSON.stringify(active)); renderGroups(); var av = $('[data-avail]'); if (av) av.setAttribute('aria-checked', draft.avail ? 'true' : 'false'); show('filter'); }

  /* ---------- checkout ---------- */
  function freshCart() {
    if (window.hsCartFresh) return Promise.resolve(window.hsCartFresh());
    return fetch('/cart.js?hs_fresh=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); });
  }
  function write(url, body) {
    var p = window.hsCartWrite ? window.hsCartWrite(url, body)
      : fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
    return Promise.resolve(p).then(function (r) { return { ok: !!(r && r.ok), status: r && r.status }; }, function () { return { ok: false, status: 0 }; });
  }
  function openCart() {
    if (window.hsOpenCart) window.hsOpenCart();
    else if (window.hsCartDrawerOpen) window.hsCartDrawerOpen();
    else window.location.href = '/cart';
  }
  var busy = false;
  /* puts the box in the cart: rental pieces already there are replaced; ReStitched
     lines stay (one checkout). Resolves the pieces that failed. */
  function boxIntoCart() {
    var HS = window.HS || {};
    var failed = [];
    return freshCart().then(function (cart) {
      var u = {}, any = false;
      (cart.items || []).forEach(function (it) {
        if (HS.isRentalLine && HS.isRentalLine(it)) { u[it.key] = 0; any = true; }
      });
      return any ? write('/cart/update.js', { updates: u }) : null;
    }).then(function () {
      var items = box.map(function (x) { return { id: parseInt(x.v, 10), quantity: 1, selling_plan: parseInt(x.pl, 10) }; });
      return write('/cart/add.js', { items: items }).then(function (r) {
        if (r.ok) return;
        /* one went out on loan meanwhile: add one by one so the rest still land */
        var chain = Promise.resolve();
        items.forEach(function (it, i) {
          chain = chain.then(function () { return write('/cart/add.js', { items: [it] }).then(function (r2) { if (!r2.ok) failed.push(box[i]); }); });
        });
        return chain;
      });
    }).then(function () { return failed; });
  }
  function afterAdd(failed, go, label) {
    busy = false; go.disabled = false; go.textContent = label;
    if (failed.length === box.length) throw new Error('add');
    if (failed.length) {
      box = box.filter(function (x) { return failed.indexOf(x) === -1; }); touched(); markSeen(); persist(); refresh(); close();
      toast(failed.length + (failed.length === 1 ? ' piece just went' : ' pieces just went') + ' out on loan. Pick ' + failed.length + ' more to finish your box.');
      return false;
    }
    markSeen(); persist(); refresh(); close();
    if (window.hsOpenBag) window.hsOpenBag(); else openCart();
    return true;
  }
  /* plan sheet button: in 'choose' mode it only records the plan */
  function checkout() {
    if (planMode === 'choose') {
      var HS0 = window.HS; if (HS0 && HS0.setPlanChoice) HS0.setPlanChoice(plan);
      push({ event: 'hs_plan_chosen', plan: plan, page: MODE });
      close(); refresh();
      try { document.dispatchEvent(new CustomEvent('hs:plan-chosen', { detail: { plan: plan } })); } catch (e) {}
      return;
    }
    var sh = $('[data-sheet="plan"]');
    goCheckout(plan, $('[data-act="checkout"]', sh), $('[data-err]', sh));
  }
  /* the explicit checkout step: plan line, the box into the cart, the offer, the cart drawer */
  function goCheckout(chosen, go, err) {
    if (busy) return;
    var label = go.textContent;
    if (!window.HS || !window.hsChoosePlan) { if (err) { err.textContent = 'Please refresh the page and try again.'; err.classList.add('on'); } else toast('Please refresh the page and try again.'); return; }
    busy = true; go.disabled = true; go.textContent = 'Adding your box…'; if (err) err.classList.remove('on');
    var t0 = performance.now();
    /* fast path (Nov 3): HS.boxCheckout puts the plan + all pieces in with ONE add and
       sets the note/offer with ONE update, then the one bag sheet opens. The old path
       below stays as the fallback (e.g. a piece went out on loan, so the add is refused). */
    if (window.HS.boxCheckout && window.hsOpenBag) {
      /* the bag sheet shows at once, busy, before any network call (Agent B's hsBagPending) */
      if (window.hsBagPending) { close(true); try { window.hsBagPending(chosen); } catch (e) {} }
      fastBox(chosen).then(function (res) {
        busy = false; go.disabled = false; go.textContent = label;
        markSeen(); persist(); refresh(); close();
        window.hsOpenBag();
        window.__hsalBoxMs = Math.round(performance.now() - t0);
        push({ event: 'hs_adbox_checkout', plan: chosen, page: MODE, ms: window.__hsalBoxMs, utm_campaign: new URLSearchParams(location.search).get('utm_campaign') || '' });
      }, function () { slowBox(chosen, go, err, label, true); });
      return;
    }
    slowBox(chosen, go, err, label);
  }
  /* clears what the box replaces (other rental pieces; a plan line of the other kind), then HS.boxCheckout */
  function fastBox(chosen) {
    var HS = window.HS;
    /* no extra cart read: the bag sheet already holds a recent copy of the cart (HSBag.state) */
    var cached = null;
    try { var bs = window.HSBag && window.HSBag.state && window.HSBag.state(); if (bs && bs.cart && bs.cart.items) cached = bs.cart; } catch (e) {}
    return (cached ? Promise.resolve(cached) : freshCart()).then(function (cart) {
      var keep = {}, u = {}, any = false;
      box.forEach(function (x) { keep[String(x.v)] = 1; });
      (cart.items || []).forEach(function (it) {
        if (HS.isRentalLine && HS.isRentalLine(it) && !keep[String(it.variant_id)]) { u[it.key] = 0; any = true; }
        else if (chosen && !HS.member && HS.isMembershipLine && HS.isMembershipLine(it)) {
          var k = HS.packageFor ? HS.packageFor(it.variant_id) : null;
          if ((k === 'once') !== (chosen === 'once')) { u[it.key] = 0; any = true; }
        }
      });
      return any ? write('/cart/update.js', { updates: u }).then(function (r) { if (!r.ok) throw new Error('clear'); return null; }) : cart;
    }).then(function (known) {
      var pieces = box.map(function (x) { return { id: parseInt(x.v, 10), quantity: 1, selling_plan: parseInt(x.pl, 10) }; });
      return HS.boxCheckout(chosen || 'member', pieces, known || undefined);
    });
  }
  function slowBox(chosen, go, err, label, pending) {
    Promise.resolve()
      .then(function () { return window.hsChoosePlan(chosen); })
      .then(function (ok) { if (ok === false) throw new Error('plan'); })
      .then(boxIntoCart)
      .then(function (failed) {
        if (chosen === 'member' && window.HS.applyOffer) return Promise.resolve(window.HS.applyOffer()).then(function () { return failed; }, function () { return failed; });
        return failed;
      })
      .then(function (failed) {
        if (afterAdd(failed, go, label)) push({ event: 'hs_adbox_checkout', plan: chosen, page: MODE, utm_campaign: new URLSearchParams(location.search).get('utm_campaign') || '' });
      })
      .catch(function () {
        if (pending && window.hsBagDone) { try { window.hsBagDone(false); } catch (e) {} }
        busy = false; go.disabled = false; go.textContent = label;
        if (err) { err.textContent = 'Something went wrong adding your box. Please try again.'; err.classList.add('on'); }
        else toast('Something went wrong adding your box. Please try again.');
      });
  }
  /* members: the five go into the cart as $0 "Membership" lines, then the cart drawer
     opens for their $0 checkout (the same path the Closet's + used for members) */
  function confirmMember() {
    if (busy) return;
    var sh = $('[data-sheet="confirm"]'), go = $('[data-act="confirm"]', sh), err = $('[data-err]', sh), label = go.textContent;
    busy = true; go.disabled = true; go.textContent = 'Adding your box…'; err.classList.remove('on');
    var useFast = window.HS && window.HS.boxCheckout && window.hsOpenBag;
    if (useFast && window.hsBagPending) { close(true); try { window.hsBagPending('member'); } catch (e) {} }
    var fast = useFast ? fastBox(null).then(function () { return []; }) : Promise.reject(0);
    fast.catch(function () { return boxIntoCart(); })
      .then(function (failed) { if (afterAdd(failed, go, label)) push({ event: 'hs_member_next_box', page: MODE }); })
      .catch(function () {
        busy = false; go.disabled = false; go.textContent = label;
        if (useFast && window.hsBagDone) { try { window.hsBagDone(false); } catch (e) {} return; }
        err.textContent = 'Something went wrong adding your box. Please try again.'; err.classList.add('on');
      });
  }
  /* ReStitched checks out with everything else in the cart (one checkout) */
  function buyCheckout() { if (window.hsOpenBag) window.hsOpenBag(); else location.href = '/cart'; }

  /* ---------- alerts ---------- */
  function notify(id, btn) {
    var d = byId[id]; if (!d) return;
    var A = window.HSAlerts;
    if (!A || !A.notifyBackInStock) { toast('Something went wrong. Please try again in a moment.'); return; }
    if (btn.classList.contains('on')) { toast('We’ll email you when it’s back', true); return; }
    btn.disabled = true;
    Promise.resolve(A.notifyBackInStock({ variantId: Number(variantFor(d, active.size) || d.v), productId: d.id, title: d.t, size: active.size ? sizeLabel(active.size) : '', handle: (d.h || '').split('/').pop(), source: 'collection-' + MODE })).then(function (ok) {
      btn.disabled = false;
      if (ok) { var n = load(NOTE_KEY) || []; if (n.indexOf(d.id) === -1) n.push(d.id); save(NOTE_KEY, n); markCards(); }
    }, function () { btn.disabled = false; });
  }
  function priceAlert(id, btn) {
    var d = byId[id]; if (!d) return;
    var A = window.HSAlerts;
    if (!A || !A.priceAlert) { toast('Something went wrong. Please try again in a moment.'); return; }
    if (btn.classList.contains('on')) {
      if (A.clearPriceAlert) { try { A.clearPriceAlert(d.id); } catch (e) {} }
      btn.classList.remove('on'); btn.setAttribute('aria-pressed', 'false'); btn.setAttribute('aria-label', 'Alert me if the price drops');
      return;
    }
    btn.disabled = true;
    Promise.resolve(A.priceAlert({ productId: d.id, variantId: d.v, handle: (d.h || '').split('/').pop(), title: d.t, price: d.r, image: d.img, url: d.h, source: 'restitched-grid' })).then(function (ok) {
      btn.disabled = false;
      if (ok) { btn.classList.add('on'); btn.setAttribute('aria-pressed', 'true'); btn.setAttribute('aria-label', 'Price alert on'); }
    }, function () { btn.disabled = false; });
  }

  /* ---------- save my box (once per visit, 1–4 pieces, × or ~45s idle) ---------- */
  var SAVE_FLAG = 'hs_savebox_shown';
  function knownEmail() {
    var A = window.HSAlerts, e = null;
    try { e = A && A.email ? A.email() : null; } catch (x) {}
    return e || (window.HS && window.HS.customerEmail) || null;
  }
  /* the saved box travels in the email link: ?hs_box=<variant>.<plan>,… (Klaviyo "Saved Box") */
  function boxUrl() {
    var q = box.filter(function (x) { return x.v && x.pl; }).map(function (x) { return x.v + '.' + x.pl; }).join(',');
    return location.origin + location.pathname + '?hs_box=' + encodeURIComponent(q) + '&utm_source=klaviyo&utm_medium=email&utm_campaign=saved_box';
  }
  function saveItems() { return box.map(function (x) { return { productId: x.id, variantId: x.v, title: x.t, image: x.img, url: x.h }; }); }
  function maybeSave() {
    if (!RENT || !box.length || box.length >= MAX || sget(SAVE_FLAG)) return;
    if (openSheet && openSheet.getAttribute('data-sheet') !== 'box') return;
    var A = window.HSAlerts;
    sset(SAVE_FLAG, '1');
    if (knownEmail()) {               /* signed in or already gave an email: no pop-up */
      if (A && A.saveBox) { try { A.saveBox({ items: saveItems(), silent: true, boxUrl: boxUrl(), source: 'collection-' + MODE }); } catch (e) {} }
      return;
    }
    var sh = $('[data-sheet="save"]'); if (!sh) return;
    thumbs(sh);
    $('[data-save-p]', sh).textContent = String(cfg.saveBody || '').replace('these [n] pieces', box.length === 1 ? 'this piece' : 'these ' + box.length + ' pieces').replace('[n]', box.length);
    $('[data-err]', sh).classList.remove('on');
    show('save');
    push({ event: 'hs_save_box_shown', n: box.length });
  }
  function submitSave() {
    var sh = $('[data-sheet="save"]'), inp = $('[data-save-email]', sh), err = $('[data-err]', sh), go = $('[data-act="savebox"]', sh);
    var email = (inp.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { err.textContent = 'Please enter a valid email.'; err.classList.add('on'); return; }
    var A = window.HSAlerts;
    try { localStorage.setItem('hs_email', email); } catch (e) {}
    if (!A || !A.saveBox) { err.textContent = 'Something went wrong. Please try again.'; err.classList.add('on'); return; }
    go.disabled = true;
    Promise.resolve(A.saveBox({ items: saveItems(), email: email, boxUrl: boxUrl(), source: 'collection-' + MODE })).then(function (ok) {
      go.disabled = false;
      if (ok === false) { err.textContent = 'Something went wrong. Please try again.'; err.classList.add('on'); return; }
      close(); toast('We’ve emailed you your box.');
    }, function () { go.disabled = false; err.textContent = 'Something went wrong. Please try again.'; err.classList.add('on'); });
  }
  var idleT;
  function idleReset() { clearTimeout(idleT); if (RENT && !sget(SAVE_FLAG)) idleT = setTimeout(function () { if (!openSheet) maybeSave(); }, 45000); }
  if (RENT) ['pointerdown', 'keydown', 'scroll', 'touchstart'].forEach(function (ev) { window.addEventListener(ev, idleReset, { passive: true }); });

  /* ---------- events ---------- */
  var lastTap = {};
  function once(key) { var now = Date.now(); if (lastTap[key] && now - lastTap[key] < 400) return false; lastTap[key] = now; return true; }
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t.closest) return;
    var el;
    if ((el = t.closest('.hsal-add')) && root.contains(el)) { e.preventDefault(); e.stopPropagation(); var id = el.closest('.hsal-card').getAttribute('data-id'); if (once('a' + id)) toggle(id); return; }
    if ((el = t.closest('.hsal-nt')) && root.contains(el)) { e.preventDefault(); e.stopPropagation(); notify(el.closest('.hsal-card').getAttribute('data-id'), el); return; }
    if ((el = t.closest('.hsal-watch')) && root.contains(el)) { e.preventDefault(); e.stopPropagation(); priceAlert(el.closest('.hsal-card').getAttribute('data-id'), el); return; }
    if ((el = t.closest('.hsal-card a')) && root.contains(el)) return;     /* Try it first */
    if ((el = t.closest('.hsal-card')) && root.contains(el)) {
      var cid = el.getAttribute('data-id'), cd = byId[cid];
      if (!RENT) { if (cd && cd.h) location.href = cd.h + (cd.h.indexOf('?') > -1 ? '&' : '?') + 'view=restitched'; return; }
      if (cd && !cd.loan) quickLook(cid);
      return;
    }
    if ((el = t.closest('.hsal-pill')) && root.contains(el)) { if (el.getAttribute('data-nav')) return; /* size pages: pills are real links */ pickSize(el.getAttribute('data-k') || ''); return; }
    if ((el = t.closest('[data-rbx]'))) { removePiece(el.getAttribute('data-rbx'), 'x'); return; }
    if ((el = t.closest('[data-swap]'))) { openSwap(el.getAttribute('data-swap')); return; }
    if ((el = t.closest('[data-swapin]'))) { swapIn(el.getAttribute('data-swapin'), el.getAttribute('data-k') || ''); return; }
    if ((el = t.closest('[data-rm]'))) {
      var rid = el.getAttribute('data-rm');
      if (RENT) removePiece(rid); else toggle(rid);
      return;
    }
    if ((el = t.closest('[data-ql-add]'))) { if (qlId && !inBox(qlId)) { if (addPiece(qlId)) close(); } else close(); return; }
    if ((el = t.closest('[data-bxs-go]'))) {
      var m = el.getAttribute('data-mode');
      if (m === 'plan') { var sp1 = storedPlan(); if (sp1 && !isMember()) { close(); goCheckout(sp1, $('[data-act="go"]', bxEl), null); } else openPlan(); } else if (m === 'buy') { close(); buyCheckout(); } else close();
      return;
    }
    if (bxEl && bxEl.contains(t) && !t.closest('[data-act]')) { openBox(); return; }
    if ((el = t.closest('[data-fv]')) && draft) {
      var g = el.closest('[data-g]').getAttribute('data-g'), v = el.getAttribute('data-fv');
      if (g === 'size' || g === 'price') draft[g] = draft[g] === v ? '' : v;
      else { if (draft[g][v]) delete draft[g][v]; else draft[g][v] = 1; }
      openG = g; renderGroups();
      return;
    }
    if ((el = t.closest('[data-avail]')) && draft) { draft.avail = !draft.avail; el.setAttribute('aria-checked', draft.avail ? 'true' : 'false'); return; }
    if ((el = t.closest('.hsal-fh'))) {
      var grp = el.parentNode.getAttribute('data-g');
      openG = openG === grp ? '' : grp; renderGroups(); return;
    }
    var act = t.closest('[data-act]');
    if (!act) return;
    var a = act.getAttribute('data-act');
    if (a === 'go') {
      if (box.length >= MAX) { var sp0 = storedPlan(); if (sp0) goCheckout(sp0, act, null); else openPlan(); }
      else if (box.length) openBox(); else toast('Tap + on a piece to start your box.');
    }
    else if (a === 'minbar') { e.preventDefault(); e.stopPropagation(); setBarMin(!bxEl.classList.contains('min')); }
    else if (a === 'changeplan') { e.preventDefault(); e.stopPropagation(); openPlan(box.length < MAX); }
    else if (a === 'checkout') checkout();
    else if (a === 'confirm') confirmMember();
    else if (a === 'savebox') submitSave();
    else if (a === 'buy') buyCheckout();
    else if (a === 'filter') openFilter();
    else if (a === 'close') { e.preventDefault(); close(); }
    else if (a === 'clearbox') { e.preventDefault(); box = []; touched(); persist(); refresh(); }
    else if (a === 'addbelow') { var ow = ownEl || grid; window.scrollTo({ top: ow.getBoundingClientRect().top + window.pageYOffset - 120, behavior: 'smooth' }); }
    else if (a === 'apply') {
      var sizeChanged = draft.size !== active.size;
      active = draft; draft = null; close(); applyFilters();
      if (sizeChanged && active.size) fillFor(active.size);
    }
    else if (a === 'clear') { e.preventDefault(); draft = { size: '', cats: {}, brands: {}, price: '', avail: false }; renderGroups(); var av0 = $('[data-avail]'); if (av0) av0.setAttribute('aria-checked', 'false'); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var t = e.target; if (!t || !t.classList) return;
    if (t.classList.contains('hsal-bx-t')) { e.preventDefault(); openBox(); }
    else if (t.getAttribute('data-act') === 'addbelow') { e.preventDefault(); t.click(); }
    else if (t.classList.contains('hsal-card') && root.contains(t)) { e.preventDefault(); quickLook(t.getAttribute('data-id')); }
  });

  /* ---------- one box: merge with the rental pieces already in the cart ---------- */
  function markSeen() { save(SEEN_KEY, box.map(idOf)); }
  function isPiece(it) {
    var HS = window.HS;
    if (HS && HS.isRentalLine) return HS.isRentalLine(it);
    var sp = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan;
    return !!(sp && /membership/i.test(sp.name || '') && it.final_line_price === 0);
  }
  function fromLine(it) {
    var id = String(it.product_id), d = byId[id];
    var x = d ? slim(d, '') : { id: id, t: it.product_title, b: it.vendor || '', r: 0, img: it.image || '', h: (it.url || '').split('?')[0] };
    x.v = String(it.variant_id); x.pl = String(it.selling_plan_allocation.selling_plan.id);
    if (!x.sz && it.variant_title) x.sz = it.variant_title;
    return x;
  }
  var syncing = false;
  function syncFromCart() {
    if (!RENT || syncing || busy) return;
    syncing = true;
    freshCart().then(function (cart) {
      syncing = false;
      if (busy) return;
      var lines = (cart.items || []).filter(function (it) { return isPiece(it) && it.selling_plan_allocation; });
      var C = lines.map(function (it) { return String(it.product_id); });
      var S = load(SEEN_KEY);
      var before = box.map(idOf).join(',');
      if (S && S.length) box = box.filter(function (x) { return !(S.indexOf(idOf(x)) > -1 && C.indexOf(idOf(x)) === -1); });
      var left = 0;
      lines.forEach(function (it) {
        var id = String(it.product_id);
        if (inBox(id) || (S && S.indexOf(id) > -1)) return;
        if (box.length >= MAX) { left++; return; }
        box.push(fromLine(it));
      });
      save(SEEN_KEY, C);
      if (box.map(idOf).join(',') !== before) { touched(); persist(); refresh(); }
      if (left) toast('Your box holds 5 pieces, so ' + left + (left === 1 ? ' piece' : ' pieces') + ' from your cart did not fit. Tap your box to review.');
    }, function () { syncing = false; });
  }
  if (RENT) {
    window.addEventListener('pageshow', function (ev) { if (ev.persisted) syncFromCart(); });
    /* Nov 4 2026: when Supercycle's check removes a piece from the cart (hs-schema), the box follows */
    window.addEventListener('hs:bag-changed', function () { setTimeout(syncFromCart, 300); });
    var cdTries = 0, cdWatch = setInterval(function () {
      var cd = document.getElementById('hs-cd');
      if (cd || ++cdTries > 40) {
        clearInterval(cdWatch);
        if (!cd || !window.MutationObserver) return;
        var was = cd.classList.contains('open');
        new MutationObserver(function () { var o = cd.classList.contains('open'); if (was && !o) syncFromCart(); was = o; })
          .observe(cd, { attributes: true, attributeFilter: ['class'] });
      }
    }, 250);
  }
  window.addEventListener('storage', function (e) {
    if (e.key === BOX_KEY && RENT) { var s = load(BOX_KEY); box = ((s && s.items) || []).slice(0, MAX); touched(); refresh(); emit(); }
  });

  /* ---------- the rest of the closet (Shopify gives 250 per page) ---------- */
  function loadMore() {
    var pages = parseInt(grid.getAttribute('data-pages'), 10) || 1;
    if (pages < 2) return Promise.resolve();
    var sid = root.getAttribute('data-sid');
    var jobs = [];
    for (var p = 2; p <= Math.min(pages, 6); p++) {
      var q = new URLSearchParams(location.search); q.set('page', p); q.set('section_id', sid);
      jobs.push(fetch(location.pathname + '?' + q.toString(), { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }, function () { return ''; }));
    }
    return Promise.all(jobs).then(function (htmls) {
      var firstLoan = list.filter(function (d) { return d.loan; })[0];
      htmls.forEach(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        $$('[data-grid] .hsal-card', doc).forEach(function (c) {
          var el = document.importNode(c, true);
          var d = parse(el);
          if (byId[d.id]) return;
          if (d.loan) grid.insertBefore(el, emptyEl); else grid.insertBefore(el, firstLoan ? firstLoan.el : emptyEl);
          register(el);
        });
      });
      list.sort(function (a, b) { return (a.loan ? 1 : 0) - (b.loan ? 1 : 0); });
    });
  }

  /* the "+" fades in once its photo has loaded (no floating buttons on grey boxes) */
  function markLoaded(scope) {
    $$('.hsal-card .im', scope || root).forEach(function (im) {
      if (im.classList.contains('ld')) return;
      var img = im.querySelector('img');
      var done = function () { im.classList.add('ld'); };
      if (!img || (img.complete && img.naturalWidth)) done();
      else { img.addEventListener('load', done, { once: true }); img.addEventListener('error', done, { once: true }); setTimeout(done, 4000); }
    });
  }
  markLoaded();

  /* ---------- start ---------- */
  var pre = '';
  (function () {
    var map = { nb: 'newborn', newborn: 'newborn', '0-3m': '0-3', '0-3': '0-3', '3-6m': '3-6', '3-6': '3-6', '6-12m': '6-12', '6-12': '6-12', '12-18m': '12-18', '12-18': '12-18', '18-24m': '18-24', '18-24-months': '18-24', '18-24': '18-24', '2t': '2t', '3t': '3t' };
    var q = (new URLSearchParams(location.search).get('size') || '').toLowerCase();
    pre = map[q] || root.getAttribute('data-pre') || '';
  })();
  showPills();
  active.size = pre;
  applyFilters();
  refresh();
  /* arriving from the "Saved Box" email: refill the box from ?hs_box= (available pieces only, max 5) */
  var savedParam = RENT ? new URLSearchParams(location.search).get('hs_box') : null;
  function restoreSaved() {
    if (!savedParam) return;
    var want = savedParam.split(',').map(function (s) { return s.split('.')[0]; }).filter(Boolean);
    savedParam = null;
    var next = [];
    want.forEach(function (v) {
      if (next.length >= MAX) return;
      var d = list.filter(function (x) { return x.vs.some(function (y) { return y.v === v && y.a; }); })[0];
      if (!d || d.loan || !d.pl || next.some(function (y) { return y.id === d.id; })) return;
      var s = slim(d, ''); var vi = -1;
      d.vs.forEach(function (y, i) { if (y.v === v) vi = i; });
      s.v = v; s.sz = vi > -1 ? varLabel(d, vi) : s.sz;
      next.push(s);
    });
    try { var u = new URL(location.href); ['hs_box', 'utm_source', 'utm_medium', 'utm_campaign'].forEach(function (k) { if (k === 'hs_box' || u.searchParams.get('utm_campaign') === 'saved_box') u.searchParams.delete(k); }); history.replaceState(null, '', u.pathname + (u.search || '') + u.hash); } catch (e) {}
    if (!next.length) { toast('The pieces in your saved box have gone out on loan. Pick new ones below.'); return; }
    box = next; touched(); sset(SAVE_FLAG, '1'); persist(); refresh();
    push({ event: 'hs_saved_box_return', n: next.length, missing: want.length - next.length });
    setTimeout(function () { openBox(); if (want.length > next.length) toast((want.length - next.length) + (want.length - next.length === 1 ? ' piece has' : ' pieces have') + ' gone out on loan since you saved your box.'); }, 300);
  }
  loadMore().then(function () {
    LOADING = false;
    restoreSaved(); markLoaded();
    showPills(); applyFilters(); markCards();
    if (pre && READY) fillFor(pre);
  });
  if (RENT) syncFromCart();
  idleReset();
  window.addEventListener('resize', measureBar);

  /* size ads: the offer line from HS.offer; "✓ Applied" when the offer code is on the cart */
  if (MODE === 'size') {
    var okEl = $('[data-applied]', root);
    var markApplied = function () {
      var o = offer(), ln = $('[data-line]', root);
      if (ln) ln.innerHTML = '<b>' + esc(o.firstLabel) + '</b> first month, then ' + esc(o.thenLabel) + '/month · 5 pieces at a time' + (okEl ? okEl.outerHTML : '');
      okEl = $('[data-applied]', root);
      /* honest: "✓ Applied" for the offer code; another working code (e.g. a FALL39 ad link) is named, never priced */
      freshCart().then(function (cart) {
        if (!okEl) return;
        var codes = ((cart && cart.discount_codes) || []).filter(function (x) { return x.applicable; });
        var mine = codes.filter(function (x) { return String(x.code).toUpperCase() === String(o.code).toUpperCase(); })[0];
        var other = codes.filter(function (x) { return x !== mine; })[0];
        var tick = okEl.querySelector('svg') ? okEl.querySelector('svg').outerHTML : '';
        if (other && !mine) { okEl.innerHTML = tick + esc(String(other.code).toUpperCase()) + ' applied'; okEl.classList.add('on'); }
        else { okEl.innerHTML = tick + 'Applied'; okEl.classList.toggle('on', !!mine); }
      }, function () {});
    };
    markApplied(); setTimeout(markApplied, 1500);
    document.addEventListener('hs:offer-applied', markApplied);
  }
  loadBag();
  ['hs:bag-changed'].forEach(function (ev) { window.addEventListener(ev, function () { if (!RENT) setTimeout(loadBag, 300); }); });
  document.addEventListener('hs:plan-chosen', renderBar);
  window.addEventListener('storage', function (e) { if (e.key === 'hs_plan') renderBar(); });
  /* the cart's own plan line wins over the remembered choice (hs-rent-once, Nov 3) */
  window.addEventListener('hs:plan', function () { renderBar(); });
  document.addEventListener('hs:alerts-ready', markCards);
  document.addEventListener('hs:alerts-changed', markCards);
  emit();
})();
